export function obtenerPagosRealizados(schedule, payments = []) {
  if (!Array.isArray(schedule) || !Array.isArray(payments)) return [];

  return schedule.filter(({ cuota }) => {
    return payments.some((p) => {
      if (typeof p === "object" && p !== null) {
        return Number(p.installment) === Number(cuota);
      }
      return Number(p) === Number(cuota);
    });
  });
}
